export const SENTRY_IGNORE_ERRORS = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  'Can\'t find variable: ZiteReader',
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268/how-to-stop-javascript-injection-from-vodafone-proxy
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',
  // Avast extension error
  '_avast_submit',
  'UCShellJava.sdkEventFire',
  'vivoNewsDetailPage.getNewsReadStatus4Vivo is not a function',
  'window.sogouMobileExplorer.triggerEvent',
  'vivo_checkMediaPausedReason',
  'extractNovelContent',
  '$ is not defined',
  'window.bannerNight is not a function',
  // ReportingObserver warnings
  /ReportingObserver \[deprecation\]: /
]
